// Set webpack public path
__webpack_public_path__ = document.querySelector('meta[name="base_assets"]').content;

import {HadronCollider} from "@webreact/webreactor";
import {components} from "./src";
import {routelist} from "./src"

const componentRouter = new HadronCollider(components, routelist);

componentRouter.loadEvents();